module.exports = __webpack_public_path__ + "static/img/-M8_ATUZ3Nq9TuG16MhR.a68e631.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/-M8_ATUZ3Nq9TuG16MhR.jpg
// module id = 4fKj
// module chunks = 1